import React from "react";

const LegendaUsers = () => {
  return (
    <table className="table table-striped table-condensed legenda-mapa">
      <thead>
        <tr>
          <th colSpan="2" style={{ paddingBottom: 7 }}>
            <span
              className="font-weight-bold text-center"
              style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}
            >
              GÊNERO DOS USUÁRIOS
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <img src="/img/markers/masc_blue.png" alt="Masculino" />
          </td>
          <td>Usuário masculino</td>
        </tr>

        <tr>
          <td>
            <img src="/img/markers/fem_pink.png" alt="Feminino" />
          </td>
          <td>Usuário feminino</td>
        </tr>

        <tr>
          <td>
            <img src="/img/markers/others.png" alt="Outros" />
          </td>
          <td>Outros</td>
        </tr>
      </tbody>
    </table>
  );
};

export default LegendaUsers;
